import styled from '@emotion/styled';

export const PageContainer = styled.div`
  max-width: 1000px;
  align-self: center;
`;

export const BlueText = styled.span`
  font-weight: bold;
  color: var(--accent-blue-600);
`;

export const AboveCardSpace = styled.div`
  height: 90px;
  justify-content: space-around;
  display: flex;
  flex-direction: column;
`;

// The error log id is always Latin text that starts with digits. When it is embedded in an RTL
// translation (Hebrew), the bidi algorithm gives its leading digits a different embedding level
// than the rest of the id, and the reordering pass throws them across the surrounding text
// ("69 :קוד השגיאה dcf1d41..."). Isolating the id keeps it a single LTR run in any language.
export const LtrText = styled.span`
  direction: ltr;
  unicode-bidi: isolate;
`;
